import { LossePlaatjie } from '@ubo/losse-sjedel'
import Content from '~/components/elements/Content'
import type { Page_Flexcontent_Flex_Text } from '~/graphql/types'

export default function TextWithImage({ fields }: { fields: Page_Flexcontent_Flex_Text }) {
  return (
    <section id="TextWithImage" className="bg-lm-shoe">
      <div className="container section">
        <div className="max-w-screen-lg mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
          <div className="col-span-1">
            <Content className="text-white">{fields.description}</Content>
          </div>
          <div>
            <LossePlaatjie maxWidth={1000} src={fields.image} alt="text-with-image" />
          </div>
        </div>
      </div>
    </section>
  )
}
